import { jsx as _jsx } from "react/jsx-runtime";
import { Children, isValidElement } from 'react';
import { styled } from '../../utils';
const DataTableRowFooterStyled = styled('div')(() => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
}));
export const DataTableRowFooter = ({ children }) => (_jsx(DataTableRowFooterStyled, { children: Children.map(children, (child, i) => {
        if (isValidElement(child)) {
            return _jsx("div", { children: child }, i);
        }
    }) }));
